import { type } from './../action'

let _cascadeMenu = localStorage.getItem("_cascadeMenu");
const intState = {
    menuName:JSON.parse(_cascadeMenu)
}
export default (state=intState,action)=>{
    switch (action.type) {
        case type.SWITCH_MENU:
            return {
                ...state,
                menuName:action.menuName
            };
        default:
            return {...state};
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducer/index.js